(() => {
  const BASE_CURRENCY = 'INR';
  const CURRENCY_SYMBOLS = {
    INR: '₹',
    GBP: '£',
    USD: '$',
    AED: 'AED',
    AUD: 'A$',
    SAR: 'SAR',
    CAD: 'C$',
    EUR: '€',
  };
  const STORAGE_KEY = 'hadiyah_display_currency';
  const COUNTRY_STORAGE_KEY = 'hadiyah_display_country';
  const AUTO_CURRENCY_KEY = 'hadiyah_auto_location_currency';
  const AUTO_COUNTRY_KEY = 'hadiyah_auto_location_country';
  const MONEY_SELECTOR = [
    '[data-money-cents]',
    '.price-item',
    '.money',
    '.m-res-price',
    '.cart-addon-card__price',
    '.cart-item__price-wrapper',
    '.totals__total-value',
    '[data-cart-item-price]',
  ].join(',');
  const currencyOptions = Array.from(
    document.querySelectorAll('[data-display-currency-option]')
  );
  const supportedCurrencies = new Set(
    currencyOptions.map((option) => option.dataset.currency)
  );
  const currencyCountries = Object.fromEntries(
    currencyOptions.map((option) => [
      option.dataset.currency,
      option.dataset.country,
    ])
  );
  const countryCurrencies = {
    IN: 'INR',
    GB: 'GBP',
    US: 'USD',
    AE: 'AED',
    AU: 'AUD',
    SA: 'SAR',
    NL: 'EUR',
    CA: 'CAD',
    FR: 'EUR',
    EU: 'EUR',
  };

  function getSavedCurrency() {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return supportedCurrencies.has(saved) ? saved : null;
    } catch (_error) {
      return null;
    }
  }

  function getSavedCountry() {
    try {
      const saved = localStorage.getItem(COUNTRY_STORAGE_KEY);
      if (!saved) return null;
      const savedCurrencyCode = getSavedCurrency();
      const match = currencyOptions.find(
        (option) =>
          option.dataset.country === saved &&
          (!savedCurrencyCode || option.dataset.currency === savedCurrencyCode)
      );
      if (match) return saved;
      if (savedCurrencyCode === 'EUR' && (saved === 'NL' || saved === 'FR')) {
        return 'EU';
      }
      return null;
    } catch (_error) {
      return null;
    }
  }

  function getCountryForCurrency(currency) {
    const visitorCountry = (
      document.querySelector('[data-display-currency-root]')?.dataset.visitorCountry ||
      window.Shopify?.country ||
      ''
    ).toUpperCase();
    const visitorMatch = currencyOptions.find(
      (option) =>
        option.dataset.currency === currency && option.dataset.country === visitorCountry
    );
    if (visitorMatch) return visitorMatch.dataset.country;
    if (currency === 'EUR') return 'EU';
    return currencyCountries[currency] || 'IN';
  }

  function getDetectedCurrency() {
    const root = document.querySelector('[data-display-currency-root]');
    const visitorCurrency = root?.dataset.visitorCurrency?.toUpperCase();
    if (supportedCurrencies.has(visitorCurrency)) return visitorCurrency;

    const country = (
      root?.dataset.visitorCountry ||
      window.Shopify?.country ||
      ''
    ).toUpperCase();

    return countryCurrencies[country] || (country && country !== 'IN' ? 'USD' : BASE_CURRENCY);
  }

  function getPageCurrency() {
    return String(window.Shopify?.currency?.active || BASE_CURRENCY).toUpperCase();
  }

  function ensureAutoLocationSeed() {
    try {
      const existing = localStorage.getItem(AUTO_CURRENCY_KEY);
      if (supportedCurrencies.has(existing)) return existing;

      const currency = getDetectedCurrency();
      const country = getCountryForCurrency(currency);
      localStorage.setItem(AUTO_CURRENCY_KEY, currency);
      localStorage.setItem(AUTO_COUNTRY_KEY, country);
      return currency;
    } catch (_error) {
      return getDetectedCurrency();
    }
  }

  function getAutoLocationCurrency() {
    try {
      const saved = localStorage.getItem(AUTO_CURRENCY_KEY);
      if (supportedCurrencies.has(saved)) return saved;
    } catch (_error) {}
    return ensureAutoLocationSeed();
  }

  function getAutoLocationCountry() {
    try {
      const saved = localStorage.getItem(AUTO_COUNTRY_KEY);
      if (saved) return saved;
    } catch (_error) {}
    return getCountryForCurrency(getAutoLocationCurrency());
  }

  function saveCurrency(currency, country) {
    try {
      localStorage.setItem(STORAGE_KEY, currency);
      if (country) localStorage.setItem(COUNTRY_STORAGE_KEY, country);
    } catch (_error) {
      // Storage can be unavailable in private browsing.
    }
  }

  function clearSavedCurrency() {
    try {
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(COUNTRY_STORAGE_KEY);
    } catch (_error) {
      // Storage can be unavailable in private browsing.
    }
  }

  const savedCurrency = getSavedCurrency();
  let autoLocationEnabled = !savedCurrency;
  let selectedCurrency = savedCurrency || getAutoLocationCurrency();
  let selectedCountry =
    getSavedCountry() ||
    (autoLocationEnabled ? getAutoLocationCountry() : getCountryForCurrency(selectedCurrency));
  let ratesPromise = null;
  let ratesReady = false;
  let formatMoneyWrapped = false;
  const formatters = new Map();

  function getCurrencySymbol(currency, country) {
    const matchedOption = Array.from(
      document.querySelectorAll('[data-display-currency-option]')
    ).find((option) => {
      if (option.dataset.currency !== currency) return false;
      if (!country) return true;
      if (currency === 'EUR' && (country === 'NL' || country === 'FR')) {
        return option.dataset.country === 'EU';
      }
      return option.dataset.country === country;
    });

    return (
      matchedOption?.dataset.currencySymbol ||
      CURRENCY_SYMBOLS[currency] ||
      currency
    );
  }

  function syncSelectors() {
    document.querySelectorAll('[data-display-currency-root]').forEach((root) => {
      root.dataset.currency = selectedCurrency;
      root.dataset.country = selectedCountry;
      root.dataset.currencyReady = 'true';
      root.dataset.autoLocation = autoLocationEnabled ? 'true' : 'false';
      const code = root.querySelector('[data-display-currency-code]');
      const symbol = root.querySelector('[data-display-currency-symbol]');
      const flag = root.querySelector('[data-display-currency-flag]');
      const autoIcon = root.querySelector('[data-display-currency-auto-icon]');
      const toggle = root.querySelector('[data-display-currency-toggle]');
      if (code) code.textContent = selectedCurrency;
      if (symbol) {
        symbol.textContent = getCurrencySymbol(selectedCurrency, selectedCountry);
      }

      if (autoLocationEnabled) {
        if (flag) flag.hidden = true;
        if (autoIcon) autoIcon.hidden = false;
      } else {
        if (flag) {
          flag.hidden = false;
          flag.className = `icon-flag icon-flag--${selectedCountry}`;
        }
        if (autoIcon) autoIcon.hidden = true;
      }

      if (toggle) {
        toggle.setAttribute(
          'aria-label',
          `Choose display currency. ${autoLocationEnabled ? 'Auto location selected. ' : ''}Current currency ${selectedCurrency}; checkout is charged in INR.`
        );
      }

      root.querySelector('[data-display-currency-auto]')?.setAttribute(
        'aria-selected',
        String(autoLocationEnabled)
      );
      root.querySelectorAll('[data-display-currency-option]').forEach((option) => {
        option.setAttribute(
          'aria-selected',
          String(
            !autoLocationEnabled &&
              option.dataset.currency === selectedCurrency &&
              option.dataset.country === selectedCountry
          )
        );
      });
    });
  }

  function loadRates() {
    if (window.Currency?.convert) {
      ratesReady = true;
      return Promise.resolve();
    }
    if (ratesPromise) return ratesPromise;

    const source = document.querySelector('[data-display-currency-root]')?.dataset.ratesSrc;
    if (!source) return Promise.reject(new Error('Currency rates source is unavailable.'));

    ratesPromise = new Promise((resolve, reject) => {
      const existing = document.getElementById('display-currency-rates');
      const script = existing || document.createElement('script');

      const onLoad = () => {
        if (window.Currency?.convert) {
          ratesReady = true;
          resolve();
        } else {
          reject(new Error('Currency rates library did not initialize.'));
        }
      };

      script.addEventListener('load', onLoad, { once: true });
      script.addEventListener('error', () => reject(new Error('Unable to load currency rates.')), { once: true });

      if (!existing) {
        script.src = source;
        script.defer = true;
        script.id = 'display-currency-rates';
        document.head.appendChild(script);
      }
    });

    return ratesPromise;
  }

  function parseMoneyAmount(text) {
    const normalized = String(text || '').replace(/\u00a0/g, ' ').trim();
    let match = normalized.match(
      /(?:₹|Rs\.?|INR|USD|GBP|EUR|AED|AUD|SAR|CAD|\$|£|€|A\$|C\$|د\.?إ?|ر\.?س?)\s*([\d,]+(?:\.\d+)?)/i
    );
    if (!match) match = normalized.match(/([\d,]+(?:\.\d+)?)\s*(?:INR|USD|GBP|EUR|AED|AUD|SAR|CAD|د\.?إ?|ر\.?س?)/i);
    if (!match) match = normalized.match(/([\d,]+(?:\.\d+)?)/);
    if (!match) return null;

    const amount = Number(match[1].replace(/,/g, ''));
    return Number.isFinite(amount) ? amount : null;
  }

  function getBaseAmount(element) {
    if (element.dataset.moneyCents) {
      const cents = Number(element.dataset.moneyCents);
      if (Number.isFinite(cents)) {
        if (!element.dataset.baseDisplay) element.dataset.baseDisplay = element.textContent.trim();
        if (!element.dataset.baseCurrency) element.dataset.baseCurrency = getPageCurrency();
        return cents / 100;
      }
    }

    if (element.dataset.baseAmount != null) return Number(element.dataset.baseAmount);
    if (element.dataset.inrAmount != null) return Number(element.dataset.inrAmount);

    const amount = parseMoneyAmount(element.textContent);
    if (amount == null) return null;

    element.dataset.baseAmount = String(amount);
    element.dataset.baseDisplay = element.textContent.trim();
    element.dataset.baseCurrency = getPageCurrency();
    // Legacy keys used by older converts.
    element.dataset.inrAmount = String(amount);
    element.dataset.inrDisplay = element.dataset.baseDisplay;
    return amount;
  }

  function getFormatter(currency) {
    if (!formatters.has(currency)) {
      const fractionDigits = currency === 'KWD' ? 3 : 2;
      const numberFormatter = new Intl.NumberFormat('en', {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
      });
      const symbol = CURRENCY_SYMBOLS[currency] || currency;
      const symbolSpacing = currency === 'AED' || currency === 'SAR' ? '\u00a0' : '';

      formatters.set(currency, {
        format(value) {
          return `${symbol}${symbolSpacing}${numberFormatter.format(value)}`;
        },
      });
    }
    return formatters.get(currency);
  }

  function formatConverted(baseAmount, fromCurrency = getPageCurrency()) {
    const sourceCurrency = String(fromCurrency || getPageCurrency()).toUpperCase();
    if (sourceCurrency === selectedCurrency) {
      return getFormatter(selectedCurrency).format(baseAmount);
    }
    const converted = Number(window.Currency.convert(baseAmount, sourceCurrency, selectedCurrency));
    if (!Number.isFinite(converted) || (baseAmount > 0 && converted <= 0)) return null;
    return getFormatter(selectedCurrency).format(converted);
  }

  function convertElement(element) {
    if (!(element instanceof HTMLElement)) return;
    if (element.childElementCount > 0 && !element.dataset.moneyCents) return;

    const baseAmount = getBaseAmount(element);
    if (baseAmount == null) return;
    const fromCurrency = element.dataset.baseCurrency || getPageCurrency();
    const formattedAmount = formatConverted(baseAmount, fromCurrency);
    if (!formattedAmount) return;

    if (!element.dataset.baseDisplay) element.dataset.baseDisplay = element.textContent.trim();
    if (!element.dataset.inrDisplay) element.dataset.inrDisplay = element.dataset.baseDisplay;
    element.textContent =
      (element.dataset.moneyPrefix || '') +
      formattedAmount +
      (element.dataset.moneySuffix || '');
    element.dataset.displayCurrencyConverted = selectedCurrency;
    element.title = `Approximate display price in ${selectedCurrency}. Checkout is charged in ${BASE_CURRENCY}.`;
  }

  function restoreElement(element) {
    if (!(element instanceof HTMLElement)) return;
    const original = element.dataset.baseDisplay || element.dataset.inrDisplay;
    if (!original) return;
    element.textContent = original;
    delete element.dataset.displayCurrencyConverted;
    element.removeAttribute('title');
  }

  function forEachMoneyElement(root, callback) {
    if (!(root instanceof Element || root instanceof Document)) return;
    if (root instanceof Element && root.matches(MONEY_SELECTOR)) callback(root);
    root.querySelectorAll(MONEY_SELECTOR).forEach(callback);
  }

  function needsConversion() {
    return selectedCurrency !== getPageCurrency();
  }

  function applyToRoot(root = document) {
    if (!needsConversion()) {
      forEachMoneyElement(root, restoreElement);
      return;
    }
    if (!ratesReady) return;
    forEachMoneyElement(root, convertElement);
  }

  function wrapShopifyFormatMoney() {
    if (formatMoneyWrapped || !window.Shopify?.formatMoney) return;
    formatMoneyWrapped = true;
    const originalFormatMoney = window.Shopify.formatMoney.bind(window.Shopify);

    window.Shopify.formatMoney = function (cents, format) {
      if (!needsConversion() || !ratesReady) {
        return originalFormatMoney(cents, format);
      }
      const numericCents = typeof cents === 'string' ? Number(cents.replace('.', '')) : Number(cents);
      if (!Number.isFinite(numericCents)) return originalFormatMoney(cents, format);
      return formatConverted(numericCents / 100, getPageCurrency()) || originalFormatMoney(cents, format);
    };
  }

  async function setCurrency(currency, { persist = true, country = null } = {}) {
    if (!supportedCurrencies.has(currency)) return;
    selectedCurrency = currency;
    selectedCountry = country || getCountryForCurrency(currency);
    if (persist) {
      autoLocationEnabled = false;
      saveCurrency(currency, selectedCountry);
    }
    syncSelectors();

    try {
      if (needsConversion()) {
        await loadRates();
        wrapShopifyFormatMoney();
      }
      applyToRoot(document);
    } catch (error) {
      console.warn('[display-currency]', error);
      selectedCurrency = getPageCurrency();
      selectedCountry = getCountryForCurrency(selectedCurrency);
      if (persist) saveCurrency(selectedCurrency, selectedCountry);
      syncSelectors();
      applyToRoot(document);
    }

    document.dispatchEvent(
      new CustomEvent('display-currency:changed', {
        detail: {
          currency: selectedCurrency,
          country: selectedCountry,
          autoLocation: autoLocationEnabled,
        },
      })
    );
  }

  function useAutoLocation() {
    autoLocationEnabled = true;
    clearSavedCurrency();
    ensureAutoLocationSeed();
    return setCurrency(getAutoLocationCurrency(), {
      persist: false,
      country: getAutoLocationCountry(),
    });
  }

  function observeDynamicPrices() {
    const roots = [
      document.getElementById('MainContent'),
      document.querySelector('cart-drawer'),
      document.querySelector('[data-cart-addon-drawer]'),
    ].filter(Boolean);

    const observer = new MutationObserver((mutations) => {
      if (!needsConversion()) return;
      if (!ratesReady) return;
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) applyToRoot(node);
        });
      });
    });

    roots.forEach((root) => observer.observe(root, { childList: true, subtree: true }));
  }

  document.addEventListener('click', (event) => {
    const autoOption = event.target.closest?.('[data-display-currency-auto]');
    if (autoOption) {
      const root = autoOption.closest('[data-display-currency-root]');
      const menu = root?.querySelector('.native-currency-selector__menu');
      const toggle = root?.querySelector('[data-display-currency-toggle]');
      if (menu) menu.hidden = true;
      root?.removeAttribute('data-open');
      toggle?.setAttribute('aria-expanded', 'false');
      useAutoLocation();
      return;
    }

    const option = event.target.closest?.('[data-display-currency-option]');
    if (option) {
      const root = option.closest('[data-display-currency-root]');
      const menu = root?.querySelector('.native-currency-selector__menu');
      const toggle = root?.querySelector('[data-display-currency-toggle]');
      if (menu) menu.hidden = true;
      root?.removeAttribute('data-open');
      toggle?.setAttribute('aria-expanded', 'false');
      setCurrency(option.dataset.currency, { country: option.dataset.country });
      return;
    }

    const toggle = event.target.closest?.('[data-display-currency-toggle]');
    if (toggle) {
      const root = toggle.closest('[data-display-currency-root]');
      const menu = root?.querySelector('.native-currency-selector__menu');
      const shouldOpen = Boolean(menu?.hidden);

      document.querySelectorAll('[data-display-currency-root]').forEach((item) => {
        const itemMenu = item.querySelector('.native-currency-selector__menu');
        const itemToggle = item.querySelector('[data-display-currency-toggle]');
        if (itemMenu) itemMenu.hidden = true;
        item.removeAttribute('data-open');
        itemToggle?.setAttribute('aria-expanded', 'false');
      });

      if (shouldOpen && root && menu) {
        menu.hidden = false;
        root.dataset.open = 'true';
        toggle.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    document.querySelectorAll('[data-display-currency-root][data-open]').forEach((root) => {
      if (root.contains(event.target)) return;
      const menu = root.querySelector('.native-currency-selector__menu');
      const rootToggle = root.querySelector('[data-display-currency-toggle]');
      if (menu) menu.hidden = true;
      root.removeAttribute('data-open');
      rootToggle?.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-display-currency-root][data-open]').forEach((root) => {
      const menu = root.querySelector('.native-currency-selector__menu');
      const toggle = root.querySelector('[data-display-currency-toggle]');
      if (menu) menu.hidden = true;
      root.removeAttribute('data-open');
      toggle?.setAttribute('aria-expanded', 'false');
      toggle?.focus();
    });
  });

  window.HadiyahDisplayCurrency = {
    ...(window.HadiyahDisplayCurrency || {}),
    setCurrency,
    useAutoLocation,
    ensureAutoLocationSeed,
    getAutoLocationCurrency,
    refresh(root = document) {
      applyToRoot(root);
    },
    getCurrency() {
      return selectedCurrency;
    },
    isAutoLocation() {
      return autoLocationEnabled;
    },
  };

  ensureAutoLocationSeed();
  syncSelectors();
  observeDynamicPrices();
  if (needsConversion()) {
    setCurrency(selectedCurrency, {
      persist: false,
      country: selectedCountry,
    });
  }
})();
